export default "2b1c63206db091e7.svg"